module.exports = __webpack_public_path__ + "static/media/cloud1.76e138fb.png";